/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type ExternalSignupResponseNext = typeof ExternalSignupResponseNext[keyof typeof ExternalSignupResponseNext];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalSignupResponseNext = {
  platform: 'platform',
  'tfa-verification': 'tfa-verification',
  'login-pending-activation': 'login-pending-activation',
  'email-verification': 'email-verification',
  'mobile-verification': 'mobile-verification',
  migration: 'migration',
  'signup-no-password': 'signup-no-password',
  'setup-password': 'setup-password',
  password: 'password',
  'user-suspended': 'user-suspended',
  'user-closed': 'user-closed',
  solution: 'solution',
} as const;
